<template>
  <div class="account-role-manage">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
    </action-bar>
    <card-table
      :item-meta-title="metaTitle"
      :item-meta-data="metaData"
      :table-data="list"
      :operator="operator"
      :paging="paging"
      @pagination="handleSizeOrPageChange"
    >
      <template slot="userStatus" slot-scope="{ param }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="param.Status == 'normal' ? '启用该用户' : '禁用该用户'"
          placement="top"
        >
          <el-switch
            v-model="param.Status"
            active-value="normal"
            inactive-value="stopped"
            @change="changeStatus(param)"
          >
          </el-switch>
        </el-tooltip>
      </template>
    </card-table>
    <add-role ref="addRole" @update:list="getList()"></add-role>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import addRole from './addRole'
export default {
  name: 'List',
  components: {
    addRole
  },
  data() {
    return {
      metaTitle: {
        label: '角色名称',
        value: 'Name'
      },
      metaData: [
        { label: '角色描述', value: 'Description' },
        { label: '状态', value: 'Status', slotName: 'userStatus' }
      ],
      btnList: [
        {
          btnContent: '新增角色',
          click: () => {
            return this.addRole()
          },
          icon: 'icon-add'
        }
      ],
      // 设置table的列
      tableCol: [
        { prop: 'Name', label: '角色名称' },
        {
          prop: 'Description',
          label: '角色描述'
        },
        { prop: 'Status', label: '状态', slotName: 'userStatus' }
      ],
      // table的基本操作
      operator: [
        {
          text: '配置权限',
          click: (data, meta) => {
            return this.settingAuth(data)
          },
          icon: 'icon-setting'
        }
      ],
      operateCol: {
        minWidth: 174
      }
    }
  },
  computed: {
    ...mapState({
      list: state => state.system.role_list,
      paging: state => state.system.role_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getRoleLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit
      }
      this.getRoleLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    addRole() {
      this.$refs.addRole.handleOpen()
    },
    settingAuth(data) {
      this.$router.push({
        name: 'roleSetting',
        query: {
          roleId: data.Id,
          roleName: data.Name
        }
      })
    },
    changeStatus(param) {
      this.$apis.system.reviseRole(param).then(res => {
        if (res) {
          this.$message.success(`${param.Name}状态更新成功`)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

.account-role-manage {
  .card-table-wrap {
    height: 100%;
    min-height: var(--base-main-router-body-avaliable-height-with-action-bar);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--base-main-router-body-avaliable-height-with-action-bar);
      }

      .card-table {
        height: 100%;
        min-height: var(--base-main-router-body-avaliable-height-with-action-bar);
      }
    }
  }
}
</style>
